import Button from 'components/UI/V3/Button/Button';
import { Tooltip } from 'components/UI/V3/Tooltip/Tooltip';
import clsx from 'clsx';
import React from 'react';
import { useReportBuilder } from './ReportBuilderProvider';
import styles from './ReportBuilder.module.scss';

interface ReportFooterProps {
    onSave: () => void;
    onSend: () => void;
    className?: string;
}

const ReportFooterComponent: React.FC<ReportFooterProps> = ({ onSave, onSend, className }) => {
    const { isSaving, hasPersistedReport, hasUnsavedChanges, generalNotes, activities } = useReportBuilder();

    const hasReportContent = generalNotes.trim().length > 0 || activities.length > 0;
    const saveDisabled = isSaving || !hasReportContent;
    const saveHint = !hasReportContent ? 'Add notes or an activity before saving.' : null;

    const sendDisabled = !hasPersistedReport || hasUnsavedChanges;
    const sendHint = !hasPersistedReport
        ? 'Save the report before sending.'
        : hasUnsavedChanges
        ? 'Save your changes before sending.'
        : null;

    return (
        <div className={clsx(styles.footer, className)}>
            <div className={styles.footerActions}>
                <div className={styles.actionWrapper}>
                    {saveHint ? (
                        <Tooltip
                            content={saveHint}
                            placement="top"
                        >
                            <Button
                                label="Save Report"
                                variant="outlined"
                                size="large"
                                fullWidth
                                disabled={saveDisabled}
                                onClick={onSave}
                            />
                        </Tooltip>
                    ) : (
                        <Button
                            label="Save Report"
                            variant="outlined"
                            size="large"
                            fullWidth
                            disabled={saveDisabled}
                            onClick={onSave}
                        />
                    )}
                </div>
                <div className={styles.actionWrapper}>
                    {sendHint ? (
                        <Tooltip
                            content={sendHint}
                            placement="top"
                        >
                            <Button
                                label="Send Report"
                                variant="green"
                                size="large"
                                fullWidth
                                disabled={sendDisabled}
                                onClick={onSend}
                            />
                        </Tooltip>
                    ) : (
                        <Button
                            label="Send Report"
                            variant="green"
                            size="large"
                            fullWidth
                            disabled={sendDisabled}
                            onClick={onSend}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export const ReportFooter = React.memo(ReportFooterComponent);
